import React from "react";
import { automationTestIds } from "../../testing/automationTestIds";

const CfLoader = () => {
  return (
    <div
      id={automationTestIds.cfLoader}
      className=" w-20 h-20 border-b-gray-150 border-r-gray-150 border-t-cfPrimaryCardHover border-l-cfPrimaryCardHover border-8 rounded-full self-center animate-spin"
    />
  );
};

export default CfLoader